import {
  DailyState, ActionTypes, REQUEST_POSTS, RECEIVE_POSTS, UPDATE_UNTIL, REQUEST_FAILED,
} from "./types"
import createReducer from "../createReducer"
/**初始化状态 */
const ini: DailyState = {
  reports: [],
  isFetching: false,
  since: '',
  until: '',
  allLoaded: false,
  lenLastFetch: 0,
  isFirstFetch: false,
  status: true,
}
/** 更新请求中的状态*/
function posts(state = ini, action: REQUEST_POSTS): DailyState {
  return {
    ...state,
    isFetching: true,
  }
}
/**请求失败 */
function failed(state = ini, action: REQUEST_FAILED) {
  return {
    ...state,
    isFetching: false,
    status: action.status
  }
}
/**请求成功，将拿到的结果保存到store */
function receive(state = ini, action: RECEIVE_POSTS) {
  return {
    ...state,
    isFetching: false,
    reports: action.reports,
    since: action.since,
    until: action.until,
    allLoaded: action.allLoaded,
    lenLastFetch: action.lenLastFetch,
    isFirstFetch: action.isFirstFetch
  }
}
/** 更新until值*/
function updateUntil(state = ini, action: UPDATE_UNTIL) {
  return {
    ...state,
    until: action.until
  }
}

export const reportReducer = createReducer<DailyState, ActionTypes>(ini, {
  REQUEST_POSTS: posts,
  RECEIVE_POSTS: receive,
  UPDATE_UNTIL: updateUntil,
  REQUEST_FAILED: failed,
})

